"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_TOKEN_HEADER = void 0;
exports.postWithToken = postWithToken;
exports.preWithToken = preWithToken;
const AuthorizationStore_1 = __importDefault(require("../../stores/AuthorizationStore"));
exports.AUTH_TOKEN_HEADER = 'Authorization';
const previousPortalTokens = new Map();
function postWithToken(context) {
    return Promise.resolve(context.response);
}
function preWithToken(context, audience, scopes) {
    const { url, init } = context;
    const fetchParams = { url, init };
    const headers = new Headers(fetchParams.init.headers);
    const previousToken = previousPortalTokens.get(audience) ?? null;
    headers.delete(exports.AUTH_TOKEN_HEADER);
    return Promise.resolve()
        .then(() => {
        if (!AuthorizationStore_1.default.auth0?.isAuthenticated) {
            return;
        }
        return AuthorizationStore_1.default.auth0?.getAccessTokenSilently().then((token) => {
            const options = {
                audience,
                ignoreCache: previousToken !== token,
                scope: ['email', 'offline_access'].concat(scopes).join(' '),
            };
            return AuthorizationStore_1.default.auth0?.getAccessTokenSilently(options).then((accessToken) => {
                previousPortalTokens.set(audience, token);
                headers.set(exports.AUTH_TOKEN_HEADER, 'Bearer ' + accessToken);
            });
        });
    })
        .then(() => {
        fetchParams.init.headers = headers;
        return fetchParams;
    });
}
